import { render, staticRenderFns } from "./price-agreement-import.vue?vue&type=template&id=3b1e0ab2"
import script from "./price-agreement-import.vue?vue&type=script&lang=js"
export * from "./price-agreement-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports